<template>
  <div class="payment-callback-container">
    <div class="card">
      <div class="card-body text-center">
        <div v-if="loading" class="my-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">處理中...</span>
          </div>
          <p class="mt-3">正在處理您的支付，請稍候...</p>
        </div>
        
        <div v-else-if="success" class="my-5">
          <div class="check-icon mb-4">
            <i class="fas fa-check-circle text-success fa-5x"></i>
          </div>
          <h3 class="text-success">支付成功！</h3>
          <p>您的訂單已成功完成，感謝您的購買。</p>
          <p class="mb-4">訂單編號: {{ orderId }}</p>
          <button class="btn btn-primary" @click="goToHome">返回首頁</button>
        </div>
        
        <div v-else class="my-5">
          <div class="error-icon mb-4">
            <i class="fas fa-times-circle text-danger fa-5x"></i>
          </div>
          <h3 class="text-danger">支付失敗</h3>
          <p>很抱歉，您的支付未能完成。</p>
          <p class="mb-4">{{ errorMessage }}</p>
          <button class="btn btn-primary" @click="tryAgain">重新嘗試</button>
          <button class="btn btn-outline-secondary ms-3" @click="goToHome">返回首頁</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';

const router = useRouter();
const route = useRoute();
const loading = ref(true);
const success = ref(false);
const errorMessage = ref('');
const orderId = ref('');

onMounted(async () => {
  try {
    // 從 URL 獲取訂單 ID 和交易 ID
    const urlParams = new URLSearchParams(window.location.search);
    orderId.value = urlParams.get('orderId');
    const transactionId = urlParams.get('transactionId');
    
    // 如果是模擬模式，直接顯示成功
    if (urlParams.get('mock') === 'true') {
      handleMockPayment(orderId.value);
      return;
    }
    
    if (!orderId.value) {
      throw new Error('訂單 ID 未提供');
    }
    
    // 向後端確認支付狀態
    const response = await axios.post('/api/line_pay_confirm/', {
      orderId: orderId.value,
      transactionId: transactionId
    });
    
    if (response.data.success) {
      success.value = true;
    } else {
      throw new Error(response.data.message || '支付處理失敗');
    }
  } catch (error) {
    console.error('支付回調處理錯誤:', error);
    success.value = false;
    errorMessage.value = error.message || '處理支付時發生未知錯誤';
  } finally {
    loading.value = false;
  }
});

// 處理模擬支付
async function handleMockPayment(orderId) {
  try {
    // 向後端確認模擬支付
    const response = await axios.post('/api/line_pay_confirm_mock/', {
      orderId: orderId
    });
    
    if (response.data.success) {
      success.value = true;
    } else {
      throw new Error(response.data.message || '模擬支付處理失敗');
    }
  } catch (error) {
    console.error('模擬支付處理錯誤:', error);
    success.value = false;
    errorMessage.value = error.message || '處理模擬支付時發生未知錯誤';
  } finally {
    loading.value = false;
  }
}

function goToHome() {
  router.push('/');
}

function tryAgain() {
  router.push('/recharge');
}
</script>

<style scoped>
.payment-callback-container {
  max-width: 600px;
  margin: 3rem auto;
  padding: 0 1rem;
}

.card {
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.check-icon, .error-icon {
  font-size: 4rem;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style> 